import * as React from 'react';
import { addLocaleData, IntlProvider } from 'react-intl';
import messages from '../../locales';
import * as en from 'react-intl/locale-data/en';
import * as fr from 'react-intl/locale-data/fr';
import * as nl from 'react-intl/locale-data/nl';
import { LocaleStore } from '../../store';
import { inject, observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';

addLocaleData([...en, ...fr, ...nl]);

interface LocaleProviderProps {
  LocaleStore?: Instance<typeof LocaleStore>;
}

@inject('LocaleStore')
@observer
class LocaleProvider extends React.Component<LocaleProviderProps> {
  public render() {
    const localeStore = this.props.LocaleStore!;
    // localeStore.setCurrentLocale(LanguageCode.fr);
    return (
      // tslint:disable-next-line:max-line-length
      /*Don't remove the key prop (it's needed for dynalic local modification): https://github.com/yahoo/react-intl/wiki/Components#dynamic-language-selection*/
      <IntlProvider
        key={localeStore.currentLocale}
        locale={localeStore.currentLocale}
        messages={messages[localeStore.currentLocale]}
      >
        <React.Fragment>{[this.props.children]}</React.Fragment>
      </IntlProvider>
    );
  }
}

export default LocaleProvider;
